import React from "react";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import AboutPageComponent from "../components/AboutPageComponent";
const AboutPage = () =>{
    return(
        <div className="main-container">
            <NavBar/>
            <AboutPageComponent/>
            <Footer/>
        </div>
    )
}
export default AboutPage